<script>
import prettyBytes from 'pretty-bytes';

export default {
  data() {
    return {
      imageFileTypes: ['jpg', 'png', 'gif', 'ico', 'svg'],
    };
  },
  computed: {
    fileExtension() {
      return this.item?.fields?.file?.value?.extension?.toUpperCase();
    },
    fileUrl() {
      return this.item?.fields?.file?.value?.src;
    },
    fileSizeInBytes() {
      return this.item?.fields?.file?.value?.size;
    },
    isImageFile() {
      if (!this.fileExtension) {
        return false;
      }
      return this.imageFileTypes.includes(this.fileExtension.toLowerCase());
    },
    image() {
      return this.item?.fields?.image?.value?.src;
    },
    itemTitle() {
      return this.item?.fields?.title?.value;
    },
    itemSource() {
      return this.item?.fields?.source?.value;
    },
  },
  methods: {
    getFileSize(bytes) {
      const prettyBytesFn = IS_SSR ? prettyBytes.default : prettyBytes;
      return prettyBytesFn(parseInt(bytes, 10), { maximumFractionDigits: 1 });
    },
    getFileSizeAndLabel(bytes) {
      return `${this.$dict.get('media-Library.Items.Size-Label')} ${this.getFileSize(bytes)}`;
    },
  },
};
</script>
